var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { setupCalendar, DatePicker } from 'v-calendar';
import * as moment from "moment";
setupCalendar({});
var DateRangePicker = /** @class */ (function (_super) {
    __extends(DateRangePicker, _super);
    function DateRangePicker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.localStart = _this.start || null;
        _this.localEnd = _this.end || null;
        return _this;
    }
    DateRangePicker.prototype.onStartChanged = function (val) { this.localStart = val; };
    DateRangePicker.prototype.onLocalStartChanged = function (val) { this.$emit("update:start", val); };
    DateRangePicker.prototype.onEndChanged = function (val) { this.localEnd = val; };
    DateRangePicker.prototype.onLocalEndChanged = function (val) { this.$emit("update:end", val); };
    Object.defineProperty(DateRangePicker.prototype, "value", {
        get: function () {
            return {
                start: this.localStart,
                end: this.localEnd
            };
        },
        enumerable: true,
        configurable: true
    });
    DateRangePicker.prototype.onChange = function (range) {
        this.localStart = range.start;
        this.localEnd = range.end;
        this.$refs.picker.popoverForceHidden = true;
    };
    DateRangePicker.prototype.formatDayOfWeek = function (val) {
        return moment(val).utc().startOf("day").format("dddd");
    };
    DateRangePicker.prototype.formatDate = function (val) {
        return moment(val).utc().startOf("day").format("MMMM Do, YYYY");
    };
    DateRangePicker.prototype.formatISO = function (val) {
        if (!val)
            return undefined;
        return moment(val).utc().startOf("day").format();
    };
    __decorate([
        Prop({ type: Date })
    ], DateRangePicker.prototype, "start", void 0);
    __decorate([
        Watch("start")
    ], DateRangePicker.prototype, "onStartChanged", null);
    __decorate([
        Watch("localStart")
    ], DateRangePicker.prototype, "onLocalStartChanged", null);
    __decorate([
        Prop({ type: Date })
    ], DateRangePicker.prototype, "end", void 0);
    __decorate([
        Watch("end")
    ], DateRangePicker.prototype, "onEndChanged", null);
    __decorate([
        Watch("localEnd")
    ], DateRangePicker.prototype, "onLocalEndChanged", null);
    __decorate([
        Prop({ type: String })
    ], DateRangePicker.prototype, "startId", void 0);
    __decorate([
        Prop({ type: String })
    ], DateRangePicker.prototype, "startName", void 0);
    __decorate([
        Prop({ type: String })
    ], DateRangePicker.prototype, "endId", void 0);
    __decorate([
        Prop({ type: String })
    ], DateRangePicker.prototype, "endName", void 0);
    DateRangePicker = __decorate([
        Component({
            name: "DateRangePicker",
            components: {
                'date-picker': DatePicker
            }
        })
    ], DateRangePicker);
    return DateRangePicker;
}(Vue));
export default DateRangePicker;
;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/Components/DateRangePicker.vue
// module id = 673
// module chunks = 24